import React, { useRef, useState, useEffect } from 'react';

const SignaturePad = ({ onSignatureChange, color }) => {
    const canvasRef = useRef(null);
    const [isDrawing, setIsDrawing] = useState(false);

    useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        // Setup high-res canvas
        const rect = canvas.getBoundingClientRect();
        canvas.width = rect.width * 2;
        canvas.height = rect.height * 2;
        ctx.scale(2, 2);

        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';
        ctx.lineWidth = 3;
        ctx.strokeStyle = color || '#000000';

        // Transparent background
        ctx.clearRect(0, 0, canvas.width, canvas.height);
    }, [color]);

    const startDrawing = (e) => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        const rect = canvas.getBoundingClientRect();

        const clientX = e.touches ? e.touches[0].clientX : e.clientX;
        const clientY = e.touches ? e.touches[0].clientY : e.clientY;

        ctx.beginPath();
        ctx.moveTo(clientX - rect.left, clientY - rect.top);
        setIsDrawing(true);
    };

    const draw = (e) => {
        if (!isDrawing) return;

        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        const rect = canvas.getBoundingClientRect();

        const clientX = e.touches ? e.touches[0].clientX : e.clientX;
        const clientY = e.touches ? e.touches[0].clientY : e.clientY;

        ctx.lineTo(clientX - rect.left, clientY - rect.top);
        ctx.stroke();
    };

    const stopDrawing = () => {
        if (!isDrawing) return;
        setIsDrawing(false);
        const canvas = canvasRef.current;
        onSignatureChange(canvas.toDataURL('image/png'));
    };

    const clearSignature = () => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        onSignatureChange(null);
    };

    return (
        <div className="flex flex-col items-center gap-2 w-full">
            <div className="relative w-full border-2 border-dashed border-purple-500/30 rounded-2xl overflow-hidden shadow-inner bg-white">
                <canvas
                    ref={canvasRef}
                    className="w-full h-32 touch-none cursor-crosshair"
                    onMouseDown={startDrawing}
                    onMouseMove={draw}
                    onMouseUp={stopDrawing}
                    onMouseLeave={stopDrawing}
                    onTouchStart={startDrawing}
                    onTouchMove={draw}
                    onTouchEnd={stopDrawing}
                />
            </div>
            <button
                type="button"
                onClick={clearSignature}
                className="text-[10px] font-black uppercase tracking-widest text-white transition-all rounded-2xl px-5 py-2 shadow-md bg-gradient-to-r from-[#5805b3] via-[#ab2ab3] to-[#f29600] hover:opacity-90 active:scale-95"
            >
                Limpiar Firma
            </button>
        </div>
    );
};

export default SignaturePad;
